export default "__VITE_ASSET__999c7a6c__"